module.exports = __webpack_public_path__ + "img/version-management-black.ac815ead.svg";